interface TablePaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export default function TablePagination({
  currentPage,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: TablePaginationProps) {
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);



  return (
    <div className="flex items-center justify-between border-t px-8 py-6">
      {/* Left */}
      <div className="flex items-center gap-2">
        <span className="text-gray-500">Show Row:</span>

        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="rounded-md border px-2 py-1 outline-none">
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>

      {/* Center */}
      <div className="flex items-center gap-3">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`text-sm transition ${
              currentPage === page
                ? "font-semibold text-black"
                : "text-gray-400 hover:text-black"
            }`}>
            {page}
          </button>
        ))}
      </div>

      {/* Right */}
      <div className="flex gap-3">
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="rounded-md border px-4 py-2 disabled:cursor-not-allowed disabled:opacity-50 hover:bg-gray-100">
          Previous
        </button>

        <button
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="rounded-md border px-4 py-2 disabled:cursor-not-allowed disabled:opacity-50 hover:bg-gray-100">
          Next
        </button>
      </div>
    </div>
  );
}
